module.exports = __webpack_public_path__ + "img/growth.93fbe8e1.svg";